<h1 mat-dialog-title>Patient Info</h1>
<div class="dialog-content" mat-dialog-content>
    <mat-form-field>
        <mat-label>ID</mat-label>
        <input matInput readonly value="{{data.id}}">
    </mat-form-field>
    <br>
    <mat-form-field>
        <mat-label>Gender</mat-label>
        <input matInput readonly value="{{data.gender}}">
    </mat-form-field>
    <br>
    <mat-form-field>
        <mat-label>birthDate</mat-label>
        <input [formControl]="date" [matDatepicker]="picker" matInput readonly>
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <br>
<!--    <div>-->
<!--        <h5>Meta Info</h5>-->
<!--        <p><b>Version:</b> {{data.meta.versionid}}</p>-->
<!--        <p><b>lastUpdated:</b> {{data.meta.lastupdated}}</p>-->
<!--    </div>-->
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" color="warn" mat-button>Close</button>
    <!--    <button mat-button color="primary" (click)="onNoClick()">Update</button>-->
</div>
